<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import BackButton from 'dashboard/components/widgets/BackButton.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import Policy from 'dashboard/components/policy.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  buttonPolicy: {
    type: Array,
    default: () => [],
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  isEmpty: {
    type: Boolean,
    default: false,
  },
  fill: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="sticky top-0 z-10 px-6 bg-n-surface-1">
      <div class="w-full max-w-5xl mx-auto">
        <div
          class="flex items-start lg:items-center justify-between w-full py-6 lg:py-0 lg:h-20 gap-4 lg:gap-2 flex-col lg:flex-row"
        >
          <div class="flex gap-3 items-center min-w-0">
            <BackButton v-if="backUrl" :back-url="backUrl" />
            <span
              v-if="headerTitle"
              class="text-heading-1 text-n-slate-12 truncate"
            >
              {{ headerTitle }}
            </span>
          </div>
          <div class="flex gap-2 shrink-0">
            <slot name="actions" />
            <Policy v-if="buttonLabel" :permissions="buttonPolicy">
              <Button
                :label="buttonLabel"
                icon="i-lucide-plus"
                size="sm"
                @click="emit('click')"
              />
            </Policy>
          </div>
        </div>
        <p
          v-if="description"
          class="pb-4 -mt-2 text-sm text-n-slate-11 max-w-2xl"
        >
          {{ description }}
        </p>
        <slot name="subHeader" />
      </div>
    </header>
    <main
      class="flex-1 px-6"
      :class="fill ? 'overflow-hidden' : 'overflow-y-auto'"
    >
      <div
        class="w-full max-w-5xl mx-auto py-4"
        :class="fill ? 'h-full min-h-0' : 'h-full'"
      >
        <div
          v-if="isFetching"
          class="flex items-center justify-center py-10 text-n-slate-11"
        >
          <Spinner />
        </div>
        <div v-else-if="isEmpty" class="h-full">
          <slot name="emptyState" />
        </div>
        <slot v-else name="body" />
      </div>
    </main>
  </section>
</template>
